export const AlertVariant = {
  Info: 'info',
  Success: 'success',
  Warning: 'warning',
  Error: 'error',
  InfoGray: 'infoGray',
  InfoDark: 'infoDark',
  Transparent: 'transparent',
} as const;

export type AlertAction = {
  label: string;
  onClick?(): void;
  href?: string;
};

export const isAlertAction = (action: unknown): action is AlertAction =>
  action !== null && typeof action === 'object' && 'label' in action && typeof action.label === 'string';
